import script from "./ImageGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGrid.vue?vue&type=script&setup=true&lang=js"

import "./ImageGrid.vue?vue&type=style&index=0&id=7c8fa24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8fa24e"]])

export default __exports__